<div class="cb-list--header">
  <div class="cb-list--header__game">
    <app-game-icon class="icon" [game]="'Case Battles'"></app-game-icon>
    <h1 class="typography-title">case battles</h1>
  </div>
  <div class="cb-list--header__total-price">
    <app-cost
      [cost]="cbService.gamesPrice()"
      [gap]="4"
      color="var(--yellow)"
    ></app-cost>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="cb-list--header__count">
    <span class="typography-small-title">
      {{ cbService.totalGames() }}
    </span>
    <span class="typography-small">total</span>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="cb-list--header__count">
    <span class="typography-small-title" style="color: var(--yellow)">
      {{ cbService.joinableGames() }}
    </span>
    <span class="typography-small">joinable</span>
  </div>
  <div class="divider vertical h-full"></div>
  <app-select
    class="cb-list--header__sort"
    [title]="'Sort by'"
    [selected]="sort()"
    [options]="sortOptions"
  />
  <div class="divider vertical h-full"></div>
  <app-fairness-button href="/provably-fair/case-battles"></app-fairness-button>
  <div class="divider vertical h-full"></div>
  <a routerLink="/battles/create" class="cb-list--header__create">
    <app-game-icon [game]="'Case Battles'" color="black"></app-game-icon>
    create battle
  </a>
</div>
@if (cbService.userBattles().length) {
<div class="cb-list--battles">
  @for (item of cbService.userBattles(); track item.uid) {
  <app-cb-list-item [game]="item"></app-cb-list-item>
  }
</div>
}
<!--  -->
@if (cbService.userBattles().length && cbService.restBattles().length) {
<span class="divider horizontal w-full"></span>
}
<!--  -->
@if (cbService.restBattles().length) {
<div class="cb-list--battles">
  @for (item of cbService.restBattles(); track item.uid) {
  <app-cb-list-item [game]="item"></app-cb-list-item>
  }
</div>
}
